define [], () ->
  saveAs = require("assets/FileSaver").saveAs

  ($state, RentappService, $timeout, $scope, $rootScope, $http, $stateParams, $sce, $uibModal, $q, $localStorage, ApplicationBundle, Landlord, Application, RENTAPPLICATION_API_URL, Flash, Raven) ->
    $scope.current_state = 'application'
    rpt_error_svg = require('./../../images/report-status-icon-error.svg')
    rpt_ready_svg = require('./../../images/report-status-icon-ready.svg')
    rpt_pending_svg = require('./../../images/report-status-icon-pending.svg')
    $scope.rpt_icon = {}

    applicationId = $stateParams.application_id
    shareToken = $stateParams.shareToken
    re = /\/(\d+)\//;

    $scope.context = $localStorage.view_only_context
  
    $scope.mobile_view = window.innerWidth < 768

    if shareToken
      $http.post "#{RENTAPPLICATION_API_URL}/api/v1/user/login/", shareToken: shareToken
      .then (response) ->
        if response.data.context
          if $localStorage.view_only_context and $localStorage.view_only_context != response.data.context
            message = "Same device using both broker and landlord view only link! from #{$localStorage.view_only_context} to #{response.data.context} by #{response.data.request_user}"
            Raven.captureMessage(message, { level: 'info' })
          $localStorage.view_only_context = response.data.context
        $state.go $state.current.name, {application_id: applicationId, shareToken: null, context: response.data.context}
      .catch (response) ->
        console.log "bad share token", shareToken
        if response.data.type == 'token_expired'
          Flash.create('danger', "Link has expired. We've just sent an email with link. Please check your email to access this application.", 0)
        $state.go 'root.home.403'
        
      return

    subMenu = $(".sticky-content")
    stickyFixed = "fixed"
    aboveSubMenuHeight = $('nav.ra-nav').height() + $('div.container').height() - 38
    $(window).scroll ->
      if $(this).scrollTop() > aboveSubMenuHeight
        subMenu.addClass stickyFixed
      else
        subMenu.removeClass stickyFixed
      return

    $scope.move_left = () ->
      toolbarTab = document.querySelector('#topbarTabs.container')
      toolbarTab.scrollLeft -= 100;

    $scope.move_right = () ->
      toolbarTab = document.querySelector('#topbarTabs.container')
      toolbarTab.scrollLeft += 100;

    $scope.set_state = (profile) ->
      $scope.found_experian_credit = false
      if profile
        if profile.identifier == "experian_credit"
          $scope.found_experian_credit = true

        $scope.current_state = profile.short_label.toLowerCase()
        $state.go("root.view_only.reports", {application: $scope.application, profile: profile})
      else
        $scope.current_state = 'application'
        $state.go("root.view_only.application", { application: $scope.application })

    $scope.load_application = (app_id) ->
      landlordDefer = $q.defer()
      profiles_to_display = []
      RentappService.getMe()
      .then (user) ->
        if user.landlord
          $scope.dashboard_link = "root.dashboard.applications"
          Landlord.getMe({with_stripe_data:true}).$promise.then (landlord) ->
            landlordDefer.resolve landlord
        else
          $scope.dashboard_link = "root.dashboard.applicant_applications"
          profiles_to_display = _.map(application.reports, 'report_source_profile')
          landlordDefer.resolve {}
      .catch (err) ->
        landlordDefer.resolve {}
      
      application = $scope.application =
        $.grep($scope.bundle.applications, (app)-> app.id == app_id)[0]
      $scope.app_field_names = []
      if application.form
        application.form.sections.forEach (section) ->
            section.fields.forEach (field) ->
              $scope.app_field_names.push field.name
      appLandlord = application.landlord


      if $scope.context == 'broker'
        profiles_to_display = []
      else
        profiles_to_display = appLandlord.report_source_profiles
        application.reports.forEach (rep) ->
          reps_profile_already_displayed = $.grep(profiles_to_display, (prof) ->
            prof.identifier == rep.report_source_profile.identifier
          ).length
          if !reps_profile_already_displayed
            profiles_to_display.push rep.report_source_profile

          if rep.status == "pending" or rep.status == "new"
            $scope.rpt_icon[rep.source_identifier] = rpt_pending_svg
          else if rep.status == "ready"
            $scope.rpt_icon[rep.source_identifier] = rpt_ready_svg
          else
            $scope.rpt_icon[rep.source_identifier] = rpt_error_svg

          return
      landlordDefer.promise.then (landlord) ->
        $scope.landlord = landlord
        profile.show_new_card_dialog = !Boolean(landlord && landlord.card_on_file) for profile in profiles_to_display
        profiles_to_display.forEach $scope.load_this_profiles_report
        $scope.profiles_to_display = profiles_to_display
        $scope.application_ready = $scope.application.status in ['A', 'R', 'S']
        $scope.application = application
        $scope.appLandlord = appLandlord
        $scope.profiles = profiles_to_display
        $scope.$broadcast 'application_loaded'
        $scope.decision_date = new Date($scope.application.decision_date)
        $scope.modified_date = new Date($scope.application.modified)
        if $scope.mobile_view
          $scope.mobile_tab_nav_width = "#{120*($scope.profiles_to_display.length + 1)}px"
          $scope.tab_width = "120px"
        else
          $scope.tab_width = "#{100.0/($scope.profiles_to_display.length + 1)}%"

        $state.go("root.view_only.application", {application: $scope.application})

    $scope.load_bundle = (selected_appid) ->
      $scope.loading_application = true;
      ApplicationBundle.query
        applications__id: selected_appid
        with_stripe_data: true
        view: true
      .$promise.then (bundle_response) ->
        bundle = bundle_response.objects[0]
        $scope.bundle = bundle
        if !bundle
          $state.go("root.home.404")
          return
        $scope.load_application(selected_appid)

      .catch ->
        $state.go "root.home.403"
      .finally () ->
        $scope.loading_application = false;

    $scope.load_bundle($stateParams.application_id)

    $scope.download_application = (application) ->
      $scope.downloading_application_pdf = true
      $http
      .get "#{RENTAPPLICATION_API_URL}#{application.pdf_url}", {responseType: 'blob'}
      .then (resp) ->
        saveAs(resp.data, "application.pdf")
      .then() ->
        $scope.downloading_application_pdf = false

    $scope.download_report = (profile) ->
      $scope.downloading_report_pdf = true
      $http.get "#{RENTAPPLICATION_API_URL}#{profile.report.report_pdf_url}",
        {responseType: 'blob'}
      .then (resp) ->
        saveAs(resp.data, profile.report.pdf_filename || profile.short_label + "-report.pdf")
        $scope.downloading_report_pdf = false;

    $scope.load_report_html = (report) ->
      if report.html
        return
      report.loading_html = true
      $http.get "#{RENTAPPLICATION_API_URL}#{report.report_html_url}"
      .then (response) -> report.html = $sce.trustAsHtml(response.data)
      .then -> report.loading_html = false


    $scope.load_this_profiles_report = (profile, application) ->
      # For Smartmove reports, reports should exist
      if profile.identifier.indexOf('smartmove') < 0
        report = _.find($scope.application.reports, {'source_identifier': profile.identifier})
      else
        report = profile.report

      # If no report is found for the profile,
      # skip trying to load report from backend
      if !report
        profile.loading = false;
        profile.report = null;
        missing_fields = _.difference(profile.report_source.required_fields, $scope.app_field_names)

        profile.can_buy_report = missing_fields.length == 0
        if !profile.can_buy_report
          profile.missing_fields = []
          missing_fields.forEach (name) ->
            profile.missing_fields.push name

        profile.card = {};
        return

      profile.loading = true;

      $http
        url: "#{RENTAPPLICATION_API_URL}#{report.resource_uri}"
        method: "GET"

      .then (resp) ->
        data = resp.data
        profile.loading = false;
        profile.report = data;

        if profile.report.status == "pending" or profile.report.status == "new"
          $scope.rpt_icon[profile.report.identifier] = rpt_pending_svg
          $timeout(
            () -> $scope.load_this_profiles_report(profile),
            30000
          )
          return;

        if profile.report.status == "ready"
          $scope.rpt_icon[profile.report.identifier] = rpt_ready_svg
          profile.loading = true;

          $http.get "#{RENTAPPLICATION_API_URL}#{profile.report.report_html_url}"
          .then (resp) ->
            profile.report.rendered_html = $sce.trustAsHtml(resp.data);
          .catch (err) ->
            if _.isObject(err)
              profile.error = {}
              profile.error.type = err.data.type
            else
              profile.error = true;
          .then () ->
            profile.loading = false;

        if profile.report.status == "not_found" || profile.report.status == "fatal"
          $scope.rpt_icon[profile.report.identifier] = rpt_error_svg

          if profile.report.error_code == 104 and profile.report.missing_fields
            profile.error = {
              "type": "missing_required_report_fields",
              "missing_fields": profile.report.missing_fields
            }
          else
            profile.error = true

      .catch () ->
        profile.error = true;

    $scope.download_bundle = () ->
      $scope.bundle.applications.forEach (application) ->
        $scope.download_package application

    $scope.download_package = (application) ->
      $scope.downloading_package = true
      zip_filename = [
        application.unit_address
        application.applicant_name
        moment(application.created).format('YYYY-MM-DD')
        application.id
      ].join('__').replace(RegExp(' ', 'g'), '_')
      attachment_requests = [ $http.get("#{RENTAPPLICATION_API_URL}#{application.pdf_url}",
        responseType: 'arraybuffer'
        contentType: 'application/pdf'
        filename: 'application.pdf').then((r) ->
        {
          'filename': "application__#{application.id}__#{application.applicant_name}.pdf"
          'data': r.data
        }
      ).catch((e) ->
        return
      ) ]

      ready_report_promises = []

      if $scope.context != 'broker'
        ready_report_promises = application.reports.filter((report) ->
          report.status == 'ready'
        ).map((report) ->
          $http.get(
            "#{RENTAPPLICATION_API_URL}#{report.report_pdf_url}",
            responseType: 'arraybuffer'
            contentType: 'application/pdf'
            filename: report.pdf_filename).then((r) ->
            {
              'filename': "report__#{report.source_identifier}__#{application.id}__#{application.applicant_name}.pdf"
              'data': r.data
            }
          ).catch (e) ->
            return
        )
        
      attachment_requests = attachment_requests.concat(ready_report_promises)
      
      attachment_promises = application.attachment_urls.map((url) ->
        $http.get("#{RENTAPPLICATION_API_URL}#{url}", responseType: 'arraybuffer').then((r) ->
          {
            'filename': r.headers('Content-Disposition').match(/filename="([^"\\]*(?:\\.[^"\\]*)*)"/i)[1]
            'data': r.data
          }
        ).catch (e) ->
          return
      )
      attachment_requests = attachment_requests.concat(attachment_promises)
      $q.all(attachment_requests).then((attachments) ->
        require.ensure [], () ->
          JSZip = require "jszip"
          zip = new JSZip
          attachments.forEach (attachment) ->
            if !attachment
              return
            zip.file attachment.filename, attachment.data, binary: true
          zip.generateAsync(type: 'blob').then (content) ->
            saveAs content, zip_filename + '.zip'
      ).finally ->
        delete $scope.downloading_package



// WEBPACK FOOTER //
// ./components/view_only/view_only.coffee